import type { Structure } from '../categories';
import type { CompType } from '../CompType';
import type { MediaManagerOptions } from './MediaManagerOptions';
import type { PhotoStudioOptions } from './PhotoStudioOptions';
import type { SectionType } from '../SectionType';
import type { AdditionalBehavior } from './propertyTypes';
import type { SectionBase, SectionItemBase } from './SectionBase';

export enum ActionSectionItemAction {
  OpenAccountSettings = 'openAccountSettings',
  OpenMediaManager = 'open_media_manager',
  AddBlankPage = 'add_blank_page',
  InstallAppAndNotify = 'install_app_and_notify',
  AddPreset = 'add_preset',
  AddCollection = 'add_collection',
  AddDataSet = 'add_dataset',
  AddFormDataSet = 'add_form_dataset',
  AddQuickActionBar = 'AddQuickActionBar',
  AddBackToTopButton = 'AddBackToTopButton',
  AddWelcomeScreen = 'AddWelcomeScreen',
  OpenPhotoStudio = 'OpenPhotoStudio',
  AddChromeThemeColor = 'AddChromeThemeColor',
  CreateNewForm = 'CreateNewForm',
  AddExistingForm = 'AddExistingForm',
}

export interface ActionSection<I = ActionSectionItem> extends SectionBase {
  type: SectionType.Action;
  additionalBehaviours?: AdditionalBehavior;
  props: {
    compTypes?: CompType[];
    class?: string;
    items: I[];
  };
}

type ActionSectionItemBase = Omit<SectionItemBase, 'body'>;

export interface ActionSectionOpenAccountSettingsItem extends ActionSectionItemBase {
  action: ActionSectionItemAction.OpenAccountSettings;
  id: string;
  title: string;
  desc: string;
  image: string;
  symbol: string;
  helpId: string;
  learnMoreText: string;
  accountSettingsPath: string;
}

export interface ActionSectionItem extends ActionSectionItemBase {
  title: string;
  desc: string;
  tooltip: string;
  image: string;
  disabled: boolean;
  disabledImage: string;
  action: ActionSectionItemAction;
  symbol: string;
  id: string;
  automationId: string;
  params?: Record<string, unknown>[];
  biItemName: string;
  mediaManagerOptions: MediaManagerOptions;
  photoStudioOptions?: PhotoStudioOptions;
  translation: { submitButton: string };
  hintProps?: { id?: string };
  category?: string;
  compType?: string;
  accountSettingsPath: string;
  disabledTooltipNoCollection: string;
  structure: Structure;
}
